import { render, staticRenderFns } from "./BudgetTechnicalCompany.vue?vue&type=template&id=a5b72a36&scoped=true"
import script from "./BudgetTechnicalCompany.vue?vue&type=script&lang=js"
export * from "./BudgetTechnicalCompany.vue?vue&type=script&lang=js"
import style0 from "./BudgetTechnicalCompany.vue?vue&type=style&index=0&id=a5b72a36&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5b72a36",
  null
  
)

export default component.exports